import { select, selectAll, addClass, removeClass, on, getModuleOptions, setAttribute } from 'modules/dom'
import { getQueryVar, addQueryVar, pipe } from 'modules/utils'
import { map } from 'modules/utils'
import { loadFormatDate, getPrevDay, dayNames, getDateFromQuery } from '../../src/js/lib/date'
import { setDataAttributes, getMobileHtmlContext, getTimes, addQueryVars, removeQueryVars, syncObjectKeys } from '../../src/js/lib/webinars'
import throttle from 'lodash.throttle'
import { Calendar } from '@fullcalendar/core'
import interactionPlugin from '@fullcalendar/interaction'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import moment from "moment";
import webinarInfoCard from '../webinar-info-card/webinar-info-card'
import { initializeModuleForEl } from '../../src/js/lib/init-modules'

const DEACTIVATE_POPOVER_CLASS = 'fc-popover__day--deactive'
const ACTIVE_POPOVER_CLASS = 'fc-popover__day--active'
const MODULE_NAME = 'webinars-calendar'
const POPOVER_MOBILE_ACTIVE_CLASS = 'webinar-popover-mobile--active'
const queryVars = ['currentStart', 'activeStart', 'activeEnd']

const getEventUrl = (calendar, dates) => `${window.location.origin}/wp-json/ecl/v1/webinar-calendar/${calendar.view.type}/${dates.activeStart}/${dates.activeEnd}`

const getEventUrlRefetch = (dates) => `${window.location.origin}/wp-json/ecl/v1/webinar-calendar/dayGridMonth/${dates.activeStart}/${dates.activeEnd}?start=${dates.activeStart}&end=${dates.activeEnd}`

const getCalendarDateRange = (calendar) => {
  const view = calendar.view
  const prevDate = getPrevDay(view.activeEnd)

  return getTimes(view.currentStart, view.activeStart, prevDate, queryVars)
}

const getStateTime = () => {
  let currentDate = new Date()
  let activeDate
  let currentTime = getQueryVar('currentStart')
  if (currentTime) {
    activeDate = currentTime
  } else {
    activeDate = currentDate
  }

  if(typeof activeDate == 'string') {
    const matches = activeDate.toString().match(/(\d{4})-(\w{3})-(\d{1,2})$/)

    if (matches) {
      return getDateFromQuery(matches)
    }
  }

  return activeDate
}

const updateEventProps = (obj) => {
  // oldKey => newKey
  const changeKeys = {
    headTitle: 'title',
    tag: 'category',
    startDate: 'calendar',
    time: 'clock'
  }
  return syncObjectKeys(obj, changeKeys)
}

export default function (el) {
  const options = getModuleOptions(MODULE_NAME, el)
  const calendarEl = select('.js-calendar', el)
  const popoverEl = select('.js-fc-popover-day', el)
  const originalPopoverEl = popoverEl.cloneNode(true)
  const popoverMobileEl = select('.js-popover-mobile', el)
  let closePopoverEl = select('.js-fc-popover-close', el)
  const nextButton = select('.js-calendar-next', el)
  const prevButton = select('.js-calendar-prev', el)
  const selectElm = select('.js-calendar-select', el)
  const calendarTitleElm = select('.js-calendar-title', el)
  const modalNullElm = select('.js-fc-modal-null', el)

  const closePopovers = () => {
    popoverEl.removeAttribute('style')
    removeClass(ACTIVE_POPOVER_CLASS, popoverEl)
    addClass(DEACTIVATE_POPOVER_CLASS, popoverEl)

    popoverEl.innerHTML = originalPopoverEl.innerHTML // reset content

    // Bind close event
    closePopoverEl = select('.js-fc-popover-close', popoverEl)
    onClosePopover(closePopoverEl)
  }

  const onClosePopover = (closePopover) => {
    if (closePopover) {
      on('click', closePopovers, closePopover)
    }
  }
  onClosePopover(closePopoverEl)

  const bindingDataPopover = (popoverEl, data) => {
    if (popoverEl && data) {
      const dataAppendBlocks = [
        {
          element: select('.js-fc-popover-headline', popoverEl),
          content: data['calendar']
        },
        {
          element: select('.js-fc-popover-presenter', popoverEl),
          content: data['presenter'],
          parentElement: select('.js-fc-popover-presenter-wrapper', popoverEl)
        },
        {
          element: select('.js-fc-popover-calendar', popoverEl),
          content: data['calendar']
        },
        {
          element: select('.js-fc-popover-description', popoverEl),
          content: data['description']
        },
        {
          element: select('.js-fc-popover-clock', popoverEl),
          content: data['timeCell']
        },
        {
          element: select('.js-fc-popover-concept', popoverEl),
          content: data['conceptList'],
          parentElement: select('.js-fc-popover-concept-wrapper', popoverEl)
        },
        {
          element: select('.js-fc-popover-excerpt', popoverEl),
          content: data['excerpt'],
          parentElement: select('.js-fc-popover-excerpt-wrapper', popoverEl)
        },
        {
          element: select('.js-fc-popover-category', popoverEl),
          content: data['category']
        }
      ]
      const urlAppendBlocks = [
        {
          element: select('.js-fc-popover-presenter-link', popoverEl),
          content: data['presenter_link'],
        }
      ]

      // Append content to element
      map(dataBlock => {
        if (dataBlock.element) {
          dataBlock.element.innerHTML = ''

          let wrapperEl = dataBlock.element
          if (dataBlock.parentElement) {
            wrapperEl = dataBlock.parentElement
          }
          addClass('hide', wrapperEl)

          if (dataBlock.content) {
            dataBlock.element.innerHTML = dataBlock.content
            removeClass('hide', wrapperEl)
          }
        }
      }, dataAppendBlocks)

      // Append URL to element
      map(dataBlock => {
        if (dataBlock.element) {
          setAttribute('href', '', dataBlock.element)

          if (dataBlock.content) {
            setAttribute('href', dataBlock.content, dataBlock.element)
          }
        }
      }, urlAppendBlocks)

      // update button
      updateButton(data, popoverEl)

      // Update title
      const popoverTitleEl = select('.js-fc-popover-title', popoverEl)
      const popoverTitleLinkEl = select('.js-fc-popover-title-link', popoverEl)
      if (popoverTitleEl && data['title']) {
        if (popoverTitleLinkEl && data['url']) {
          setAttribute('href', data['url'], popoverTitleLinkEl)
          popoverTitleLinkEl.innerHTML = data['title']
        } else {
          popoverTitleEl.innerHTML = data['title']
        }
      }
    }
  }

  const updateButton = (data, popoverEl) => {
    const popoverButtonTextEl = select('.js-fc-popover-button-text', popoverEl)
    const popoverButtonEl = select('.js-fc-popover-button', popoverEl)

    if (!data || !popoverButtonTextEl || !popoverButtonEl) return

    const buttonClass = data.button_data['button_class'] ? data.button_data['button_class'].trim() : ''

    if (buttonClass) popoverButtonEl.classList.add(buttonClass)
    if (!data.button_data.button_text && !data.button_data.button_link) {
      popoverButtonEl.href = data.url
      popoverButtonTextEl.innerHTML = `See ${data['label']}`
    } else {
      popoverButtonTextEl.innerHTML = data.button_data['button_text']
      popoverButtonEl.href = data.button_data['button_link']
    }

    if (data.button_data['button_attributes']) {
      const [key, value] = data.button_data['button_attributes'].trim().replaceAll('"', '').split('=')
      popoverButtonEl.setAttribute(key, value)
    }

    webinarInfoCard(popoverEl)

    // Re-initialize modal login
    const modalLogin = select('[data-module-init="modal-login"]')

    modalLogin && initializeModuleForEl(modalLogin)
  }
  // Example: yyyy-mm-dd (month + 1 to match @fullcalendar lib)
  const today = options.date && options.date.length ? options.date : new Date()

  const calendar = new Calendar(calendarEl, {
    plugins: [ interactionPlugin, dayGridPlugin, timeGridPlugin, listPlugin ],
    defaultDate: today,
    events: WebinarCalendarsEvents,
    header: false,
    navLinks: false, // can click day/week names to navigate views
    editable: true,
    height: 'auto',
    contentHeight: 'auto',
    aspectRatio: 1.11,
    eventLimit: true, // allow "more" link when too many events
    views: {
      dayGridMonth: {
        eventLimit: 6
      }
    },
    eventRender: function(info) {
      const fcContent = select('.fc-content', info.el)
      const startDate = info.event.start
      const now = new Date()
      if (startDate < now) {
        addClass('webinar-past', fcContent)
      }

      const fcTag = document.createElement('span')
      fcTag.style.backgroundColor =
        info.event.extendedProps.webinar_tag_color
          ? info.event.extendedProps.webinar_tag_color
          : 'transparent'
      const tagClasses = ['fc-tag', 'p-small4']
      tagClasses.forEach(className => {
        addClass(className, fcTag)
      })


      const fcTitle = select('.fc-title', info.el)
      if (fcTitle) {
        addClass('sub-heading2', fcTitle)
      }
      const fcLabel = document.createElement('span')
      const labelClasses = ['label', 'fc-label']
      labelClasses.forEach(className => {
        addClass(className, fcLabel)
      })

      const fcTime = document.createElement('span')
      const timeClasses = ['p-small', 'fc-time-ecl']
      timeClasses.forEach(className => {
        addClass(className, fcTime)
      })

      const labelTextValue = info.event.extendedProps.tag || info.event.extendedProps.label
      const labelText = document.createTextNode(labelTextValue)
      fcLabel.appendChild(labelText)
      fcContent.appendChild(fcLabel)
      fcTitle.before(fcLabel)

      const timeText = document.createTextNode(info.event.extendedProps.timeCell)
      fcTime.appendChild(timeText)
      fcContent.appendChild(fcTime)

      const tagText = document.createTextNode(info.event.extendedProps.webinar_tag)
      fcTag.appendChild(tagText)

      const fcSponsor = document.createElement('span')
      const sponsorClasses = ['fc-calendar-label', 'fc-sponsor']
      sponsorClasses.forEach(className => {
        addClass(className, fcSponsor)
      })

      const sponsorText = document.createTextNode(info.event.extendedProps.sponsorText)
      fcSponsor.appendChild(sponsorText)
      if (info.event.extendedProps.sponsorText) {
        fcContent.appendChild(fcSponsor)
      }
      fcTitle.after(fcTime)

      if (fcTag.innerHTML) {
        fcLabel.before(fcTag)
      }

    },
    eventClick: function(info) {
      info.jsEvent.preventDefault()
      const resultEvents = this.getEvents()
      const calendarRect = calendarEl.getBoundingClientRect()
      const elemRect = info.el.getBoundingClientRect()
      let offsetLeft = elemRect.left - calendarRect.left + 135
      const offsetTop = elemRect.top - calendarRect.top - 86

      const dateName = info.event.start + ''

      if (dateName.indexOf('Sat') != -1) {
        offsetLeft = elemRect.left - calendarRect.left - 258
      }

      let dataBinding = {}
      if (resultEvents) {
        map((item) => {
          let eventProps = item.extendedProps
          if (eventProps.headTitle === info.event.extendedProps.headTitle) {
            let itemProps = updateEventProps(eventProps)
            itemProps.url = item.url
            dataBinding = itemProps
          }
        }, resultEvents)
      }

      pipe(
        removeClass(DEACTIVATE_POPOVER_CLASS),
        addClass(ACTIVE_POPOVER_CLASS)
      )(popoverEl)
      bindingDataPopover(popoverEl, dataBinding)
      setAttribute('style', 'top:' + offsetTop + 'px; ' + 'left:' + offsetLeft + 'px; opacity:1; visibility:visible', popoverEl)
    },
    dateClick: function(info) {
      const resultEvents = this.getEvents()
      const fcDays = selectAll('.fc-day', calendarEl)
      removeClass('fc-day-focus', fcDays)

      if (info.dayEl) {
        addClass('fc-day-focus', info.dayEl)
      }

      const dataBinding = []
      if (resultEvents) {
        map((item) => {
          let eventProps = item.extendedProps
          if (eventProps.timeStart === info.dateStr) {
            let itemProps = updateEventProps(eventProps)
            itemProps.url = item.url
            dataBinding.push(itemProps)
          }
        }, resultEvents)
      }

      const popoverMobileContentEl = select('.js-webinar-popover-mobile-content', popoverMobileEl)
      popoverMobileContentEl.innerHTML = ''

      const popoverHeadLineEl = select('.js-fc-popover-headline', popoverMobileEl)
      if (popoverHeadLineEl) {
        const newDate = info.date
        popoverHeadLineEl.innerHTML = loadFormatDate(newDate, 'F dd')
      }

      if (dataBinding && popoverMobileEl && popoverMobileContentEl) {
        let context = getMobileHtmlContext(dataBinding)
        if (context.length > 0) {
          popoverMobileContentEl.innerHTML = context
        }
      } else {
        removeClass(POPOVER_MOBILE_ACTIVE_CLASS, popoverMobileEl)
      }
      addClass(POPOVER_MOBILE_ACTIVE_CLASS, popoverMobileEl)
      setAttribute('style', 'max-height: ' + popoverMobileEl.scrollHeight + 'px;', popoverMobileEl)
    },
    datesRender: function (info) {
      let view = info['view']
      if (calendarTitleElm) {
        calendarTitleElm.innerHTML = view.title
      }
    },
    columnHeaderHtml: function(date) {
      let context = `<i class="fc-day-header__mobile">${dayNames[date.getDay()].charAt(0)}</i>`
      context += `<i class="fc-day-header__desktop">${dayNames[date.getDay()]}</i>`
      return context
    }
  })

  calendar.render()
  calendar.gotoDate(getStateTime())

  if (popoverEl) {
    on('resize', throttle(() => {
      popoverEl.removeAttribute('style')
      pipe(
        removeClass(ACTIVE_POPOVER_CLASS),
        addClass(DEACTIVATE_POPOVER_CLASS)
      )(popoverEl)
    }, 250), window)
  }

  const updateCalendar = (calendar) => {
    closePopovers()
    refetchEventsCalendar(calendar)
    reloadHeadTitleAttributeData()
  }

  // Next/Prev buttons
  if (nextButton) {
    on('click', () => {
      calendar.next()
      updateCalendar(calendar)
    }, nextButton)
  }

  if (prevButton) {
    on('click', () => {
      calendar.prev()
      updateCalendar(calendar)
    }, prevButton)
  }

  // Check Data Event when First Load
  if (WebinarCalendarsEvents.length && calendar.view.type === "dayGridMonth") {
    modalNullElm.classList.remove('active')
  } else {
    modalNullElm.classList.add('active')
  }

  // Check Null Event in this Month
  const checkEventsInMonth = (dates) => {
    let datesRefetch = {
      activeEnd: moment(dates.activeEnd, 'YYYY-MMM-DD').format('YYYY-MM-DD'),
      activeStart: moment(dates.activeStart, 'YYYY-MMM-DD').format('YYYY-MM-DD'),
      currentStart: moment(dates.currentStart, 'YYYY-MMM-DD').format('YYYY-MM-DD')
    }
    fetch(getEventUrlRefetch(datesRefetch))
      .then((res) => res.json())
      .then((result) => {
        if (result.length) {
          modalNullElm.classList.remove('active')
        } else {
          modalNullElm.classList.add('active')
        }
      })
      .catch((e) => {
        console.log(e)
      })
  }

  // Select
  if (selectElm) {
    on('change', () => {
      calendar.changeView(selectElm.value)
      refetchEventsCalendar(calendar)
      const view = calendar.view
      const activeStartVar = getQueryVar('activeStart')
      const activeEndVar = getQueryVar('activeEnd')
      const currentTimeVar = getQueryVar('currentStart')
      let currentDate = loadFormatDate(new Date(), 'iso8601')
      let pageUrl = addQueryVar('view-by', view.type)
      let defaultDate = getCalendarDateRange(calendar)
      let current, start, end

      if (currentTimeVar && activeStartVar && activeEndVar) {
        removeQueryVars(pageUrl, queryVars)
      }

      if(view.type === 'timeGridDay') {
        current = defaultDate.currentStart
        start = current
        end = current

      } else {
        if (currentTimeVar && activeStartVar && activeEndVar) {
          currentDate = currentTimeVar
        }

        current = currentDate
        start = defaultDate.activeStart
        end = defaultDate.activeEnd
      }

      let dates = getTimes(current, start, end, queryVars, 'iso8601')

      if (dates) {
        addQueryVars(pageUrl, dates)
        setDataAttributes(calendarTitleElm, dates)
      }
    }, selectElm)
  }

  const reloadHeadTitleAttributeData = () => {
    const view = calendar.view
    const activeStartVar = getQueryVar('activeStart')
    const currentStartVar = getQueryVar('currentStart')
    const activeEndVar = getQueryVar('activeEnd')
    let pageUrl = addQueryVar('view-by', view.type)
    let defaultDate = getCalendarDateRange(calendar)
    let current, start, end

    if (activeStartVar && currentStartVar && activeEndVar) {
      removeQueryVars(pageUrl, queryVars)
    }

    switch(view.type) {
      case 'timeGridDay':
        current = defaultDate.currentStart
        start = current
        end = current

        break;

      case 'dayGridMonth':
        current = defaultDate.currentStart
        start = defaultDate.currentStart
        end = defaultDate.activeEnd

        break;

      default :
        current = activeStartVar
        start = currentStartVar
        end = activeEndVar
    }

    let dates = getTimes(current, start, end, queryVars, 'iso8601')

    addQueryVars(pageUrl, dates)
    setDataAttributes(calendarTitleElm, dates)
  }

  const refetchEventsCalendar = (calendar) => {
    if (calendar) {
      const eventSources = calendar.getEventSources()
      let dates = getCalendarDateRange(calendar)
      let eventSourceUrl = getEventUrl(calendar, dates)

      if (calendar.view.type === "dayGridMonth") {
        checkEventsInMonth(dates)
      } else {
        modalNullElm.classList.remove('active')
      }

      if (eventSources && eventSources.length && eventSourceUrl) {
        eventSources[0].remove()
        calendar.addEventSource(eventSourceUrl)
        calendar.refetchEvents()

      }
    }
  }

  // Keep scroll position
  const scrollPosition = window.sessionStorage.getItem('scrollPosition')
  if (scrollPosition) {
    window.scrollTo(0, scrollPosition)
    window.sessionStorage.removeItem('scrollPosition')
  }
}
